import { Component, OnInit } from '@angular/core';

@Component({
  selector: '[app-footer]',
  templateUrl: './app-footer.component.html'
})
export class AppFooter implements OnInit {

  godina: any;

constructor() {}

ngOnInit() {
  this.godina = new Date().getFullYear();
}

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/layouts/app-footer/app-footer.component.ts